import React, {useState, useEffect} from 'react';
import { Modal, Paper } from '@mui/material';
import EditOperatorLayout from '../layouts/EditOperatorLayout';

import getOffices from "../../../data/office/getOffices";
import {Office} from "../../../classes/Office";
import {Operator} from "../../../classes/Operator";

function UpdateOperatorModal(props: {
    isOpen: boolean,
    selectedOperatorObject: Operator,
    onClose: Function,
    onSubmit: Function,
    onNetworkError: Function
}) {
    const [officeList, setOfficeList] = useState<Office[] | undefined>(undefined)

    useEffect(() => {
        getOffices()
            .then((result) => setOfficeList(result))
            .catch((err) => {
                console.error(err)
                props.onNetworkError()
            })
    }, [])

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditOperatorLayout
                    title="Update Operator"
                    initInfo={props.selectedOperatorObject}
                    officeList={officeList}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default UpdateOperatorModal;